import React from "react";
import IframePage from "./IframePage";
import "../../../css/BoletinOficial/edictos.css";

const Edictos = () => (
  <IframePage
    title="EDICTOS"
    description="Un gobierno abierto y transparente que pone a disposición de los ciudadanos información relevante para promover mayor participación y cercanía."
    iframeUrl="https://ciudaddeoliva.gov.ar/boletin-oficial/edictos.aspx"
    classPrefix="edictos"
  />
);

export default Edictos;
